module.exports = __webpack_public_path__ + "img/about-img-ob.f29cd016.jpg";